(() => {
  if (customElements.get('sp-product-gallery')) return;

  customElements.define('sp-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      // Gallery videos are rendered without `autoplay` so their MP4s don't download during the
      // critical load; start them (muted, looping, as before) once the page has finished loading.
      const startVideos = () => {
        this.querySelectorAll('video[data-sp-autoplay]').forEach((video) => {
          video.removeAttribute('data-sp-autoplay');
          video.preload = 'auto';
          video.autoplay = true;
          const playing = video.play();
          if (playing) playing.catch(() => {});
        });
      };
      const whenIdle = () => ('requestIdleCallback' in window
        ? requestIdleCallback(startVideos, { timeout: 1500 })
        : setTimeout(startVideos, 200));
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true, signal: this.events.signal });
      const initialize = () => {
        if (!this.isConnected || this.gallery) return;
        const slider = this.querySelector('[data-gallery-slider]');
        const strip = this.querySelector('.sp-gallery-thumbs');
        if (!slider || !strip || typeof Swiper !== 'function') return;
        const buttons = [...strip.querySelectorAll('[data-media-index]')];
        const select = (index) => {
          buttons.forEach((button, position) => {
            button.setAttribute('aria-current', String(position === index));
          });
          const current = buttons[index];
          if (!current) return;
          const left = current.offsetLeft;
          const right = left + current.offsetWidth;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (right > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = right - strip.clientWidth;
        };
        this.gallery = new Swiper(slider, {
          loop: false,
          slidesPerView: 1.05,
          spaceBetween: 12,
          speed: 700,
          centeredSlides: false,
          grabCursor: true,
          watchSlidesProgress: true,
          autoplay: false,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          on: {
            init: (swiper) => select(swiper.activeIndex),
            slideChange: (swiper) => select(swiper.activeIndex),
          },
        });
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.gallery.slideTo(index), { signal: this.events.signal });
          button.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = Math.min(index + 1, buttons.length - 1);
            else if (event.key === 'ArrowLeft') next = Math.max(index - 1, 0);
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = buttons.length - 1;
            else return;
            event.preventDefault();
            buttons[next].focus({ preventScroll: true });
            this.gallery.slideTo(next);
          }, { signal: this.events.signal });
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: this.events.signal });
      } else initialize();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.gallery?.destroy(true, true);
      this.gallery = null;
    }
  });
})();
